import { createAsyncThunk } from '@reduxjs/toolkit';

import { formReadyForSendingSelector, selectStepsFields, defaultStepperConfigSelector } from 'entities/creditForm';
import { accountSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataThunk, type TSendCustomerDataThunkState } from 'features/SendCustomerData';

import { recalculateSteps } from './stepper';

export const updateUserDataThunk = createAsyncThunk<void, void, { state: TSendCustomerDataThunkState }>(
  'updateUserData/updateUserDataThunk',
  async (_, { dispatch, getState }) => {
    const user = accountSelector(getState());

    if (!user) {
      return;
    }

    const {
      activeStep,
      stepsWithMultiStepsOrder: steps,
      lastStep,
    } = recalculateSteps(defaultStepperConfigSelector(getState()));
    const isReady = formReadyForSendingSelector(getState());

    const filledSteps = steps
      .slice(0, isReady ? lastStep.stepIndex : (activeStep?.stepIndex ?? 2) - 1)
      .map((step) => step.formId);

    await dispatch(sendCustomerDataThunk(selectStepsFields(filledSteps)(getState())));
  },
);
